import _styled from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Icon } from "~/features/ui/icon";
import { Link } from "~/features/ui/link";
import Instagram from "~/public/icons/instagram.svg";
import Linkedin from "~/public/icons/linkedin.svg";
import YouTube from "~/public/icons/youtube.svg";
import X from "~/public/icons/x.svg";
const fragment = graphql(`
  fragment FooterSocial on footerSocials_social_BlockType {
    url: baseUrl
    type: footerSocialType
  }
`);
const socialBrandNames: Record<string, string> = {
  x: "X",
  twitter: "X",
  youtube: "YouTube",
  linkedin: "LinkedIn",
  facebook: "Facebook",
  instagram: "Instagram",
  github: "GitHub",
  tiktok: "TikTok"
};
const socialIconMap: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  instagram: Instagram,
  linkedin: Linkedin,
  youtube: YouTube,
  x: X,
  twitter: X
};
export function FooterSocial(props: FragmentType<typeof fragment>) {
  const {
    url,
    type
  } = useFragment(fragment, props);
  if (!url) {
    return null;
  }
  const label = type ? socialBrandNames[type] ?? type.charAt(0).toUpperCase() + type.slice(1) : undefined;
  return <_StyledLink href={url} aria-label={label} newWindow referrerPolicy="no-referrer">
      <Icon icon={socialIconMap[type ?? ""] ?? Instagram} size="32" aria-hidden />
    </_StyledLink>;
}
var _StyledLink = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "footer-social___StyledLink",
  componentId: "sc-29nqgc-0"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "transitionProperty": "opacity",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out",
  "@media (hover: hover)": {
    "&:hover": {
      "opacity": "0.6"
    }
  }
});